module.exports = __webpack_public_path__ + "b58570b6c1498df1d3a03e223f2936e8.png";